import { Button, Form, FormProps, Input, message } from "antd";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks.ts";
import { onLogin } from "../../../redux/actions/authActions.tsx";
import { useIsMobile } from "../../../hooks/useIsMobile.ts";
import { extractErrorMessage } from "../../../utils/extractErrorMessage.ts";

type FormValues = {
  email: string;
  password: string;
};

const LoginImage: React.FC = () => (
  <img
    src="/login-image.webp"
    className="max-md:w-4/5 mx-auto block object-cover mb-4"
    alt="Login image"
    width={0}
    height={0}
    sizes="30vw"
    style={{ width: "100%" }}
  />
);

export const AuthenticationForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isMobile } = useIsMobile();
  const { loading } = useAppSelector((state) => state.auth);

  const [messageApi, contextHolder] = message.useMessage();

  const onAuthenticateForm: FormProps<FormValues>["onFinish"] = async ({
    email,
    password,
  }) => {
    try {
      await dispatch(
        onLogin({
          email,
          password,
        }),
      ).unwrap();
    } catch (error: any) {
      messageApi.error(
        extractErrorMessage(error, "El correo y/o contraseña son incorrectos."),
      );
    }
  };

  return (
    <div className="font-[sans-serif]">
      {contextHolder}
      <div className="min-h-screen flex fle-col items-center justify-center py-6 px-4">
        <div className="grid md:grid-cols-2 items-center gap-4 max-w-6xl w-full">
          <div className="border border-gray-300 rounded-lg p-6 max-w-md shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)] max-md:mx-auto">
            <Form
              className={isMobile ? "w-full" : "space-y-4"}
              onFinish={onAuthenticateForm}
            >
              <div className="mx-auto text-center">
                <div className="flex justify-center items-center">
                  <img
                    src="/logo_multiburo.svg"
                    alt="Multiexpediente Multiburó"
                    className="w-4/6 sm:w-3/6"
                  />
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Accede al portal Multiexpediente para una administración
                  eficiente y segura de información crítica.
                </p>
              </div>

              <div className="flex flex-col">
                <Form.Item<FormValues>
                  label="Email"
                  labelCol={{ span: 24 }}
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Campo requerido.",
                    },
                    {
                      type: "email",
                      message: "Ingresa un email válido.",
                    },
                  ]}
                >
                  <Input type="email" className="lowercase" />
                </Form.Item>

                <Form.Item<FormValues>
                  label="Contraseña"
                  labelCol={{ span: 24 }}
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Campo requerido.",
                    },
                  ]}
                  className="mp-8"
                >
                  <Input.Password />
                </Form.Item>
              </div>

              {/*<div className="flex flex-wrap flex-row items-center justify-between gap-4">
                <Form.Item>
                  <Link to="/auth/forgot-password"
                        className="text-blue-600 hover:underline font-semibold">
                    Olvidaste tu contraseña?
                  </Link>
                </Form.Item>
              </div>*/}

              <div className="!mt-8">
                <Button
                  type="primary"
                  loading={loading}
                  htmlType="submit"
                  className="w-full shadow-xl py-6 px-7 text-sm tracking-wide rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
                >
                  Iniciar sesión
                </Button>
              </div>
            </Form>
          </div>
          <div className="lg:h-[400px] md:h-[300px] max-md:mt-8">
            {!isMobile && <LoginImage />}
          </div>
        </div>
      </div>
    </div>
  );
};
